import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface BodyProps {
  children?: ReactNode;
  className?: string;
  hasPaddingTopMobile?: boolean;
  isMinimalLayout?: boolean;
  wrapperClassName?: string;
}

export const Body = ({
  hasPaddingTopMobile = true,
  isMinimalLayout,
  children,
  className,
  wrapperClassName,
}: BodyProps) => (
  <div
    className={classNames(
      anchorClassNames("main"),
      "h-full",
      !isMinimalLayout && "lg:bg-secondary",
      className,
    )}
  >
    <div
      className={classNames(
        anchorClassNames("main__wrapper"),
        "h-full sm:mx-6 md:pt-6 lg:mx-9",
        {
          "pt-0": !hasPaddingTopMobile,
          "px-4 sm:px-0": isMinimalLayout,
        },
        wrapperClassName,
      )}
    >
      {children}
    </div>
  </div>
);
